import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "detail-schedule-form" }
const _hoisted_2 = { class: "title-form py-5 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "p-fluid px-3" }
const _hoisted_5 = { class: "p-field mb-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "agent" }, "Agen", -1)
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field mb-4 w-full" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "receiptDate" }, "Tanggal Penerimaan", -1)
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field mb-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "hoursArrival" }, [
  /*#__PURE__*/_createTextVNode("Jam Kedatangan "),
  /*#__PURE__*/_createVNode("span", { style: {"font-size":"11px","font-style":"italic"} }, "(Format : hh:mm)")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "hoursDeparture" }, [
  /*#__PURE__*/_createTextVNode("Jam Keberangkatan "),
  /*#__PURE__*/_createVNode("span", { style: {"font-size":"11px","font-style":"italic"} }, "(Format : hh:mm)")
], -1)
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = {
  class: "btn-action w-full",
  style: {"position":"absolute","bottom":"10px"}
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Multiselect, {
          id: "agent",
          class: "mt-1",
          modelValue: _ctx.v$.agent.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.agent.$model = $event)),
          placeholder: "Pilih Agen",
          options: _ctx.agentOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.agent.$invalid && _ctx.submitted) || _ctx.v$.agent.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.agent.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Multiselect, {
          id: "receiptDate",
          class: "mt-1",
          modelValue: _ctx.v$.receiptDate.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.receiptDate.$model = $event)),
          placeholder: "Pilih Tanggal Penerimaan",
          options: _ctx.receiptDateOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.receiptDate.$invalid && _ctx.submitted) || _ctx.v$.receiptDate.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.receiptDate.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_Calendar, {
          id: "hoursArrival",
          class: "input-primary mt-1",
          timeOnly: true,
          hourFormat: "24",
          modelValue: _ctx.dataForm.hoursArrival,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataForm.hoursArrival = $event)),
          placeholder: "HH:mm"
        }, null, 8, ["modelValue"]),
        ((_ctx.v$.hoursArrival.$invalid && _ctx.submitted) || _ctx.v$.hoursArrival.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.hoursArrival.validHours.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_Calendar, {
          id: "hoursDeparture",
          class: "input-primary mt-1",
          timeOnly: true,
          hourFormat: "24",
          modelValue: _ctx.dataForm.hoursDeparture,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataForm.hoursDeparture = $event)),
          placeholder: "HH:mm"
        }, null, 8, ["modelValue"]),
        ((_ctx.v$.hoursDeparture.$invalid && _ctx.submitted) || _ctx.v$.hoursDeparture.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.hoursDeparture.validHours.$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_Button, {
        label: "Simpan",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)))
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1 justify-center",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ]))
}